import React from "react";

const Legend = () => {
  const legendItems = [
    { status: "Completed", color: "bg-green-500" },
    { status: "In Progress", color: "bg-blue-500" },
    { status: "On Hold", color: "bg-yellow-500" },
    { status: "Cancelled", color: "bg-red-500" },
  ];

  return (
    <div className="absolute bottom-4 left-4 bg-white rounded-lg shadow-lg border border-gray-200 p-4 z-[1000]">
      <h3 className="text-sm font-semibold text-gray-800 mb-3">
        Project Status
      </h3>
      <div className="space-y-2">
        {legendItems.map((item) => (
          <div key={item.status} className="flex items-center gap-2">
            <div className={`w-3 h-3 rounded-full ${item.color}`}></div>
            <span className="text-xs text-gray-600">{item.status}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Legend;
